import React from 'react'
import { observable } from 'mobx'
// import get from 'lodash/get'
import { Container } from 'react-bootstrap'
import { i18nTranslate, enableNewFeature } from 'src/utils'
import {
  useStickyTop,
  getAppConfig,
  getLocalStorage,
  isB2BAccount,
  IS_BROWSER,
  isB2B2C,
  APPConfig,
} from 'config/appConfig'
import { ApiContent, scrollState } from 'src/utils'
import { catalogContainer, customerContainer } from 'src/models'

class CommonHeader extends React.Component {
  nameSpace = 'ssr-resource'
  @observable categoryResponse = {}
  header = ''

  static contextType = ApiContent
  constructor(props, context) {
    super(props)
    this.context = context
    this.contextName = 'categoryData'
    this.csContextName = 'csTopNavData'
    if (!isB2BAccount() || isB2B2C()) {
      this.getDataFromSource()
    }
    if (IS_BROWSER) {
      // document.dir = i18n.dir()
      document.dir = 'ltr'
    }
  }

  getDataFromSource = async () => {
    const categoryData = this.context?.ssrData?.[this.contextName] || {}

    if (categoryData && categoryData.category) {
      const getCSTopNav =
        APPConfig.getAppConfig()?.enableImpactSectionFromCS == 'true'

      if (getCSTopNav && !IS_BROWSER) {
        const csTopNav = this.context?.ssrData?.[this.csContextName] || {}
        const transformedResponse =
          catalogContainer.transformCategoryResponse(csTopNav)
        categoryData.category?.subCategories.push(transformedResponse)
      }
      this.categoryResponse = categoryData
      catalogContainer.categoryResponse = categoryData
    } else {
      if (enableNewFeature('enableRedesignMainMenu')) {
        return
      }
      // await customerContainer.getProfile()
      await this.getCategoryResponse()
    }
  }

  componentDidUpdate() {
    if (
      isB2BAccount() &&
      customerContainer.isRegisterUser &&
      !this.categoryResponse.category
    ) {
      /**
       * @note
       * Removing TopCategory call to prevent Multiple Call Triggering
       */
      // this.getDataFromSource()
    }
  }

  calculateHeaderSpace = () => {
    const header = this.header
    const height = header.offsetHeight
    scrollState.headerHeight = height
    if (useStickyTop) {
      document.getElementById('app-root').style.paddingTop = `${height}px`
    }
  }

  componentDidMount() {
    this.calculateHeaderSpace()
  }

  getCategoryResponse = async () => {
    const { defaultLocale } = getAppConfig()

    this.categoryResponse = await catalogContainer.getCategory({
      context: this.context,
      contextName: this.contextName,
      csContextName: this.csContextName,
      queryParams: {
        locale: defaultLocale,
      },
    })

    catalogContainer.categoryResponse = this.categoryResponse
  }

  renderAdminTopBar = () => {
    // const csrAdminName = get(sessionContainer, 'csrAdminName', '')
    const csrAdminName = getLocalStorage('csrAdminName') || ''
    return (
      !csrAdminName.includes('undefined undefined') &&
      csrAdminName !== undefined &&
      csrAdminName !== '' && (
        <section className="header-user-bar w-100 py-2 px-3 px-lg-0">
          <Container className="px-0 logged-as-user text-right text-white">
            {i18nTranslate('header.loggedAs', 'Logged in as', {
              nameSpace: this.nameSpace,
            })}
            <span className="font-weight-bold ml-1">{csrAdminName}</span>
          </Container>
        </section>
      )
    )
  }
}

export default CommonHeader
export { CommonHeader }
